import { Category } from './types';

export const MAIN_NAV_CATEGORIES: Category[] = [
  {
    title: 'Library',
    items: [
      {
        name: 'Media',
        link: 'mediaList',
        childRoutes: ['mediaDetail'],
        icon: 'player-play',
      },
      {
        name: ({ accountHas }) =>
          accountHas('live-v2') && accountHas('broadcast_live_saas')
            ? 'Live'
            : accountHas('broadcast_live_saas')
              ? 'Broadcast Live'
              : 'Instant Live',
        link: 'liveStreaming',
        childRoutes: ['liveStreamingInstantDetail', 'liveStreamingBroadcastDetail'],
        icon: 'video',
      },
      {
        name: 'Interactivity',
        link: 'interactivityList',
        childRoutes: ['interactivityProject'],
        icon: 'click',
      },
    ],
  },
  {
    title: 'Curation',
    items: [
      {
        name: 'Playlists',
        link: 'playlistList',
        childRoutes: [
          'playlistDetailDynamic',
          'playlistDetailManual',
          'playlistDetailRecommendations',
          'playlistDetailSearch',
          'playlistDetailArticleMatching',
        ],
        icon: 'playlist',
      },
      {
        name: 'Recommendations',
        link: 'recommendationsList',
        childRoutes: ['recommendationsDetail'],
        icon: 'list-check',
      },
    ],
  },
  {
    title: 'Display',
    items: [
      {
        name: 'Players',
        link: 'playersList',
        icon: 'aspect-ratio',
      },
      {
        name: 'Apps',
        link: 'appConfigsList',
        icon: 'apps',
      },
    ],
  },
  {
    title: 'Growth & Monetization',
    items: [
      {
        name: 'Strategy rules',
        link: 'strategiesList',
        childRoutes: ['placementsDetail', 'strategyDetail'],
        icon: 'sitemap',
      },
      {
        name: 'Advertising',
        link: 'advertisingList',
        childRoutes: ['advertisingDetailAdConfig', 'advertisingDetailAdSchedule'],
        icon: 'ad',
      },
      {
        name: 'Plans',
        link: 'plans',
        icon: 'tags',
      },
    ],
  },
  {
    title: 'Analytics',
    items: [
      {
        name: 'Overview',
        link: 'analyticsOverview',
        icon: 'chart-bar',
      },
      {
        name: 'Real time',
        link: 'analyticsRealtime',
        icon: 'clock-check',
      },
      {
        name: 'Reports',
        link: 'analyticsCustomReportsList',
        icon: 'clipboard-data',
      },
    ],
  },
];
